// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 合思配置表单项
 * @constructor
 */
const HoseFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "appKey"]}
        label={"AppKey"}
        placeholder={"请输入appKey"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入appKey"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "appSecurity"]}
        label={"AppSecurity"}
        placeholder={"请输入AppSecurity"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入AppSecurity"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormSelect
        name={["config", "envId"]}
        label={"环境地址"}
        placeholder={"请选择所属环境地址"}
        required
        width={"lg"}
        rules={[{
          required: true,
          message: "请选择所属环境地址"
        }]}
        fieldProps={{
          fieldNames: {
            label: "envName",
            value: "id"
          }
        }}
        request={async () => {
          const _data: any = await Api.Common.EnvList({appType: AppType.HOSE})
          return _data
        }}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default HoseFormItems
